import { render, staticRenderFns } from "./TemplatePageSettings.vue?vue&type=template&id=3ac7882a&xmlns%3Av-slot=http%3A%2F%2Fwww.w3.org%2F1999%2FXSL%2FTransform&"
import script from "./TemplatePageSettings.vue?vue&type=script&lang=js&"
export * from "./TemplatePageSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("Q:\\Projects\\marketingdatabase-git\\MarketingDb.Web.Zeiss\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3ac7882a')) {
      api.createRecord('3ac7882a', component.options)
    } else {
      api.reload('3ac7882a', component.options)
    }
    module.hot.accept("./TemplatePageSettings.vue?vue&type=template&id=3ac7882a&xmlns%3Av-slot=http%3A%2F%2Fwww.w3.org%2F1999%2FXSL%2FTransform&", function () {
      api.rerender('3ac7882a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ScriptsV2/Core/Modules/TemplateManager/Components/Settings/TemplatePageSettings.vue"
export default component.exports